import { NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { TimeToNowModule } from '@rma/dashboard/generic/util/pipes/time-to-now';
import { UserNotificationModel } from '@rma/dashboard/notification-bell/private/api-user-notifications';
import {
  NotificationContentService,
  NotificationItemContent,
  NotificationRouteData,
} from '@rma/dashboard/notification-bell/private/util-notification-content';

@Component({
  selector: 'rma-notification-item-system',
  templateUrl: 'notification-item-system.component.html',
  styleUrls: ['notification-item-system.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgTemplateOutlet, TranslocoModule, MatMenuModule, TimeToNowModule, MatButtonModule, MatBadgeModule, RouterModule],
})
export class NotificationItemSystemComponent implements OnChanges {
  @HostBinding() class = 'block';

  @Input() public notification: UserNotificationModel;
  @Input() public containerClass?: string;
  @Input() public showStatusIcon = true;

  @Output() public navigate = new EventEmitter<NotificationRouteData>();

  public content: NotificationItemContent;

  constructor(private readonly notificationContentService: NotificationContentService) {}

  ngOnChanges(): void {
    this.content = this.notificationContentService.getNotificationContent(this.notification);
  }

  public onClick() {
    this.navigate.emit({
      agentRoute: this.content.agentRoute,
      agencyRoute: this.content.agencyRoute,
    });
  }
}
